import style from "./style.scss";

const Banner = ({ children }) => (
  <header class={style.banner}>
    <div class={style.wrapper}>
      <div>{children}</div>
    </div>
  </header>
);

export default Banner;
